import { useEffect } from "react";
import { useState } from "react";
import axiosInstance from "../../../../../axiosInstance";
import { parseISO } from "date-fns";

const useCatalogLastModifiedDate = (storeId) => {
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    const getCatalogLastModifiedDate = async () => {
      setIsLoading(true);
      try {
        setError("");
        const result = await axiosInstance.post(
          "/physicalInventory/getCatalogLastModifiedDate",
          {
            storeId,
          },
          { signal: controller.signal }
        );
        if (result.data.data) setDate(parseISO(result.data.data));
        else setDate("");
      } catch (error) {
        setError(error.response?.body?.message || error.message);
      } finally {
        setIsLoading(false);
      }
    };
    getCatalogLastModifiedDate();

    return () => controller.abort();
  }, [storeId]);

  return { date, isLoading, error };
};

export { useCatalogLastModifiedDate };
